<template>
  <ul class="controls">
    <li>
      <scroll-horizontal-control-button
        direction="left"
        @click-scroll="emit('clickScrollLeft')"
      />
    </li>
    <li>
      <scroll-horizontal-control-button
        direction="right"
        @click-scroll="emit('clickScrollRight')"
      />
    </li>
  </ul>
</template>
<script setup lang="ts">
const emit = defineEmits(["clickScrollLeft", "clickScrollRight"]);
</script>
<style lang="scss" scoped>
.controls {
  display: flex;
  align-items: center;
  gap: var(--gap_s);
  li {
    display: block;
  }
}
</style>
